import { render, staticRenderFns } from "./infoquicklook.vue?vue&type=template&id=36ad4cd2&scoped=true&"
import script from "./infoquicklook.vue?vue&type=script&lang=js&"
export * from "./infoquicklook.vue?vue&type=script&lang=js&"
import style0 from "./infoquicklook.vue?vue&type=style&index=0&id=36ad4cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad4cd2",
  null
  
)

export default component.exports